<template>
  <v-dialog :value="value" max-width="500" @input="$emit('input', $event)">
    <v-card class="no-slots-popup__card" :style="{ 'background-color': backgroundColor }">
      <v-card-title class="no-slots-popup__title" :style="{ color: fontColor }"> Vagas esgotadas </v-card-title>
      <v-card-text class="no-slots-popup__text" :style="{ color: fontColor }">
        As vagas para este evento esgotaram e não é mais possível confirmar presença. Caso tenha interesse em próximos eventos, clique no botão abaixo para nos
        sinalizar.
      </v-card-text>
      <v-card-actions class="no-slots-popup__actions">
        <div class="no-slots-popup__actions-inner">
          <v-btn text class="no-slots-popup__btn-close" :style="{ color: fontColor }" @click="close"> Fechar </v-btn>
          <v-btn
            class="no-slots-popup__btn-interest"
            :loading="interestLoading"
            :disabled="interestLoading"
            :style="{
              'background-color': interestButtonBackgroundColor,
              color: interestButtonFontColor
            }"
            @click="$emit('interest')"
          >
            {{ interestButtonLabel }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'NoSlotsPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    fontColor: {
      type: String,
      default: '#000000'
    },
    interestButtonBackgroundColor: {
      type: String,
      default: '#1976d2'
    },
    interestButtonFontColor: {
      type: String,
      default: '#ffffff'
    },
    interestLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    interestButtonLabel() {
      return this.$vuetify.breakpoint.xsOnly ? 'Tenho interesse' : 'Tenho interesse em próximos eventos'
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped lang="scss">
.no-slots-popup__card {
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  max-height: 85vh;
}

.no-slots-popup__title {
  flex-shrink: 0;
  font-size: 1.25rem;
  font-weight: bold;
  text-align: center;
  justify-content: center;
  width: 100%;
  padding-top: 24px;
}

.no-slots-popup__text {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  text-align: center;
  padding-bottom: 8px;
  opacity: 0.9;
}

.no-slots-popup__actions {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  padding: 8px 16px 24px;
  width: 100%;
}

.no-slots-popup__actions-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.no-slots-popup__btn-close {
  flex-shrink: 0;
}

.no-slots-popup__btn-interest {
  flex: 1;
  min-width: 0;
}

$phone-size: 600px;

@media screen and (max-width: $phone-size) {
  .no-slots-popup__actions-inner {
    flex-direction: column-reverse;
    align-items: stretch;
  }

  .no-slots-popup__btn-close,
  .no-slots-popup__btn-interest {
    width: 100%;
    flex: none;
    margin: 0;
  }
}
</style>
